module.exports = __webpack_public_path__ + "images/saintgobain_small61951557d4b2cf3cbc7d8ac7e6b35a79.png";